
export class CornerRadiusModel {

    constructor(
        public cornerRadiusAll: number = 0,
        public cornerRadiusOption: boolean = false,
        public topLeftCornerRadius: number = 0,
        public topRightCornerRadius: number = 0,
        public bottomLeftCornerRadius: number = 0,
        public bottomRightCornerRadius: number = 0
    ) { }

    public equals(other: CornerRadiusModel): boolean {
        if (this.cornerRadiusAll !== other.cornerRadiusAll){
            return false;
        }

        if (this.cornerRadiusOption !== other.cornerRadiusOption){
            return false;
        }

        if (this.topLeftCornerRadius !== other.topLeftCornerRadius){
            return false;
        }

        if (this.topRightCornerRadius !== other.topRightCornerRadius){
            return false;
        }

        if (this.bottomLeftCornerRadius !== other.bottomLeftCornerRadius){
            return false;
        }

        if (this.bottomRightCornerRadius !== other.bottomRightCornerRadius){
            return false;
        }

        return true;
    }
}
